import React, { useEffect, useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import {
  getCommuneVil,
  getDepSp,
  getRegions,
  getSpCommune,
  regionDep,
} from 'service/api-presfor';

const FiltresCascadeRapport = ({
  onFilterChange,
  selectedRegion,
  selectedDepartement,
  selectedSousPrefecture,
  showCommune = false,
  showVillage = false,
}) => {
  const [optionsRegion, setOptionsRegion] = useState([]);
  const [optionsDepartement, setOptionsDepartement] = useState([]);
  const [optionsSousPrefecture, setOptionsSousPrefecture] = useState([]);
  const [optionsCommune, setOptionsCommune] = useState([]);
  const [optionsVillage, setOptionsVillage] = useState([]);

  const [region, setRegion] = useState(selectedRegion || '');
  const [departement, setDepartement] = useState(selectedDepartement || '');
  const [sousPrefecture, setSousPrefecture] = useState(
    selectedSousPrefecture || ''
  );
  const [commune, setCommune] = useState('');
  const [village, setVillage] = useState('');

  const REGIONS_RAPPORT = [
    'INDENIE-DJUABLIN',
    'ME',
    "N'ZI",
    'PORO',
    'SUD-COMOE',
    'TCHOLOGO',
  ];

  useEffect(() => {
    callApiRegion();
  }, []);

  useEffect(() => {
    setRegion(selectedRegion || '');
  }, [selectedRegion]);

  useEffect(() => {
    setDepartement(selectedDepartement || '');
  }, [selectedDepartement]);

  useEffect(() => {
    setSousPrefecture(selectedSousPrefecture || '');
  }, [selectedSousPrefecture]);

  function callApiRegion() {
    const req = {};
    getRegions(req)
      .then((res) => {
        const results = res?.data || [];

        const filteredRegions = results.filter((reg) =>
          REGIONS_RAPPORT.includes(reg.nom)
        );

        filteredRegions.sort((a, b) => a.nom.localeCompare(b.nom));

        const sortedOptions = filteredRegions.map((reg) => ({
          label: reg.nom,
          value: reg.nom,
        }));

        setOptionsRegion(sortedOptions);
      })
      .catch((err) => {
        console.error('Erreur lors du chargement des régions:', err);
      });
  }

  function callApiDepartement(regionName) {
    const req = {};
    regionDep(regionName, req)
      .then((res) => {
        const results = [];
        const listeDepartementparRegion = res?.data || [];

        listeDepartementparRegion.forEach((dep) => {
          results.push({
            label: dep.nom,
            value: dep.nom,
          });
        });

        setOptionsDepartement([...results]);
      })
      .catch((err) => {
        console.error('Erreur lors du chargement des départements:', err);
        setOptionsDepartement([]);
      });
  }

  function callApiSousPrefecture(departementName) {
    const req = {};
    getDepSp(departementName, req)
      .then((res) => {
        const results = [];
        const listeSousPrefectureparDepartement = res?.data || [];

        listeSousPrefectureparDepartement.forEach((sp) => {
          results.push({
            label: sp.nom,
            value: sp.nom,
          });
        });

        setOptionsSousPrefecture([...results]);
      })
      .catch((err) => {
        console.error('Erreur lors du chargement des sous-préfectures:', err);
        setOptionsSousPrefecture([]);
      });
  }

  function callApiCommune(sousPrefectureName) {
    const req = {};
    getSpCommune(sousPrefectureName, req)
      .then((res) => {
        const results = [];
        const listeCommuneparSousPrefecture = res?.data || [];

        listeCommuneparSousPrefecture.forEach((com) => {
          results.push({
            label: com.nom,
            value: com.nom,
          });
        });

        setOptionsCommune([...results]);
      })
      .catch((err) => {
        console.error('Erreur lors du chargement des communes:', err);
        setOptionsCommune([]);
      });
  }

  function callApiVillage(communeName) {
    const req = {};
    getCommuneVil(communeName, req)
      .then((res) => {
        const results = [];
        const listeVillageparCommune = res?.data || [];

        listeVillageparCommune.forEach((vil) => {
          results.push({
            label: vil.nom_vil,
            value: vil.nom_vil,
          });
        });

        setOptionsVillage([...results]);
      })
      .catch((err) => {
        console.error('Erreur lors du chargement des villages:', err);
        setOptionsVillage([]);
      });
  }

  const handleRegionChange = (e) => {
    const value = e.target.value;
    setRegion(value);

    setDepartement('');
    setSousPrefecture('');
    setCommune('');
    setVillage('');
    setOptionsDepartement([]);
    setOptionsSousPrefecture([]);
    setOptionsCommune([]);
    setOptionsVillage([]);

    if (value) {
      callApiDepartement(value);
    }

    if (onFilterChange) {
      onFilterChange({
        region: value,
        departement: '',
        sousPrefecture: '',
        commune: '',
        village: '',
      });
    }
  };

  const handleDepartementChange = (e) => {
    const value = e.target.value;
    setDepartement(value);

    setSousPrefecture('');
    setCommune('');
    setVillage('');
    setOptionsSousPrefecture([]);
    setOptionsCommune([]);
    setOptionsVillage([]);

    if (value) {
      callApiSousPrefecture(value);
    }

    if (onFilterChange) {
      onFilterChange({
        region,
        departement: value,
        sousPrefecture: '',
        commune: '',
        village: '',
      });
    }
  };

  const handleSousPrefectureChange = (e) => {
    const value = e.target.value;
    setSousPrefecture(value);

    setCommune('');
    setVillage('');
    setOptionsCommune([]);
    setOptionsVillage([]);

    if (value && showCommune) {
      callApiCommune(value);
    }

    if (onFilterChange) {
      onFilterChange({
        region,
        departement,
        sousPrefecture: value,
        commune: '',
        village: '',
      });
    }
  };

  const handleCommuneChange = (e) => {
    const value = e.target.value;
    setCommune(value);

    setVillage('');
    setOptionsVillage([]);

    if (value && showVillage) {
      callApiVillage(value);
    }

    if (onFilterChange) {
      onFilterChange({
        region,
        departement,
        sousPrefecture,
        commune: value,
        village: '',
      });
    }
  };

  const handleVillageChange = (e) => {
    const value = e.target.value;
    setVillage(value);

    if (onFilterChange) {
      onFilterChange({
        region,
        departement,
        sousPrefecture,
        commune,
        village: value,
      });
    }
  };

  return (
    <div className="grid sm:grid-cols-1 grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Région
        </label>
        <div className="relative">
          <select
            value={region}
            onChange={handleRegionChange}
            className={`w-full px-4 py-2.5 pr-10 bg-white border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none transition duration-200 ${
              region ? 'border-blue-500' : 'border-gray-300'
            }`}
          >
            <option value="">Toutes les régions</option>
            {optionsRegion.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <IoChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Département
        </label>
        <div className="relative">
          <select
            value={departement}
            onChange={handleDepartementChange}
            disabled={!region}
            className={`w-full px-4 py-2.5 pr-10 border-2 rounded-lg appearance-none transition duration-200 ${
              !region
                ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                : departement
                ? 'bg-white border-blue-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                : 'bg-white border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            }`}
          >
            <option value="">Tous les départements</option>
            {optionsDepartement.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <IoChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
        </div>
        {!region && (
          <p className="text-xs text-gray-500 mt-1">
            Sélectionnez d'abord une région
          </p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Sous-préfecture
        </label>
        <div className="relative">
          <select
            value={sousPrefecture}
            onChange={handleSousPrefectureChange}
            disabled={!departement}
            className={`w-full px-4 py-2.5 pr-10 border-2 rounded-lg appearance-none transition duration-200 ${
              !departement
                ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                : sousPrefecture
                ? 'bg-white border-blue-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                : 'bg-white border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            }`}
          >
            <option value="">Toutes les sous-préfectures</option>
            {optionsSousPrefecture.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <IoChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
        </div>
        {!departement && (
          <p className="text-xs text-gray-500 mt-1">
            Sélectionnez d'abord un département
          </p>
        )}
      </div>

      {showCommune && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Commune
          </label>
          <div className="relative">
            <select
              value={commune}
              onChange={handleCommuneChange}
              disabled={!sousPrefecture}
              className={`w-full px-4 py-2.5 pr-10 border-2 rounded-lg appearance-none transition duration-200 ${
                !sousPrefecture
                  ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                  : commune
                  ? 'bg-white border-blue-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                  : 'bg-white border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
              }`}
            >
              <option value="">Toutes les communes</option>
              {optionsCommune.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <IoChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
          </div>
          {!sousPrefecture && (
            <p className="text-xs text-gray-500 mt-1">
              Sélectionnez d'abord une sous-préfecture
            </p>
          )}
        </div>
      )}

      {showVillage && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Village
          </label>
          <div className="relative">
            <select
              value={village}
              onChange={handleVillageChange}
              disabled={!commune}
              className={`w-full px-4 py-2.5 pr-10 border-2 rounded-lg appearance-none transition duration-200 ${
                !commune
                  ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
                  : village
                  ? 'bg-white border-blue-500 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                  : 'bg-white border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
              }`}
            >
              <option value="">Tous les villages</option>
              {optionsVillage.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <IoChevronDown className="absolute right-3 top-3 text-gray-400 pointer-events-none" />
          </div>
          {!commune && (
            <p className="text-xs text-gray-500 mt-1">
              Sélectionnez d'abord une commune
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default FiltresCascadeRapport;
